/*
Made by Reza and Bowrand Team
hello@bowrand.com
www.bowrand.com
*/
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        const variantInput = this.variantIdInput;
        if (variantInput) variantInput.disabled = false;

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification');
        this.submitButton = this.querySelector('[type="submit"]');
        if (!this.submitButton) return;
        this.submitButtonText = this.submitButton.querySelector('span');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        let variantId = null;
        const fiboliVariantInput = document.getElementById('FiboliRealVariantId');
        if (fiboliVariantInput && fiboliVariantInput.value) {
          variantId = fiboliVariantInput.value.trim();
        } else {
          variantId = formData.get('id');
          if (!variantId) {
            const variantInput = this.form.querySelector('[name="id"]');
            if (variantInput && variantInput.value) {
              variantId = variantInput.value.trim();
            }
          }
        }
        if (!variantId || variantId === '') {
          this.handleErrorMessage('Please select a product variant.');
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.classList.remove('loading');
          const spinner = this.querySelector('.loading__spinner');
          if (spinner) spinner.classList.add('hidden');
          return;
        }
        const variantIdNum = parseInt(variantId, 10);
        if (isNaN(variantIdNum) || variantIdNum <= 0) {
          console.error('Invalid variant ID:', variantId);
          this.handleErrorMessage('Invalid product variant selected.');
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.classList.remove('loading');
          const spinner = this.querySelector('.loading__spinner');
          if (spinner) spinner.classList.add('hidden');
          return;
        }
        const allIds = formData.getAll('id');
        allIds.forEach(() => formData.delete('id'));
        formData.set('id', variantIdNum.toString());
        const quantityInput = this.form.querySelector('input[name="quantity"]');
        let quantityToAdd = '1';
        if (quantityInput && quantityInput.value) {
          const inputValue = parseInt(quantityInput.value, 10);
          if (!isNaN(inputValue) && inputValue > 0) {
            quantityToAdd = Math.min(Math.max(1, inputValue), 10).toString();
          }
        }
        const quantityEntries = formData.getAll('quantity');
        quantityEntries.forEach(() => formData.delete('quantity'));
        formData.set('quantity', quantityToAdd);
        console.log('ProductForm - Variant ID:', variantIdNum, 'Quantity:', quantityToAdd);
        if (this.submitButton.dataset.submitting === 'true') {
          return;
        }
        this.submitButton.dataset.submitting = 'true';
        
        if (this.cart) {
          const sectionsToRequest = this.cart.getSectionsToRender().map((section) => {
            return section.section || section.id;
          }).filter(Boolean);
          
          if (sectionsToRequest.length > 0) {
            formData.append('sections', sectionsToRequest.join(','));
          }
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
          })
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) {
                this.error = true;
                return;
              }
              this.submitButton.setAttribute('aria-disabled', true);
              if (this.submitButtonText) this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                if (this.cart && typeof this.cart.renderContents === 'function') {
                  this.cart.renderContents(response);
                }
              });
            }
          })
          .catch((e) => {
            console.error('Add to cart error:', e);
            this.handleErrorMessage('Unable to add product to cart. Please try again.');
            this.error = true;
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.submitButton.dataset.submitting = 'false';
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            const spinner = this.querySelector('.loading__spinner');
            if (spinner) spinner.classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form?.querySelector('[name=id]');
      }
    }
  );
}
